import React from "react"
import { Input } from "antd"
import type { InputProps } from "antd/lib/input"

export const TextInput = (props: InputProps): JSX.Element => {
  return <Input {...props} />
}
